import apiClient from "./axiosConfig";

export const getAdminCount = async () => {
  const response = await apiClient.get("/users/admin/count/");
  return response.data;
};

export const getEmployeeList = async (params) => {
  const { page = 1, page_size = 25, search, status, role } = params;
  const queryParams = new URLSearchParams({
    page,
    page_size,
    ...(search && { search }),
    ...(status && { status }),
    ...(role && { role }),
  });
  const response = await apiClient.get(`/users/list/admin/?${queryParams}`);
  return response.data;
};

export const deleteEmployee = async (id) => {
  const response = await apiClient.delete(`/users/admin/delete/${id}/`);
  return response.data;
};

export const updateEmployeeStatus = async (id, status) => {
  const response = await apiClient.patch(`/users/admin/status/${id}/`, {
    status,
  });
  return response.data;
};

export const updateEmployee = async (id, data) => {
  const response = await apiClient.put(`/users/admin/update/${id}/`, data);
  return response.data;
};

export const createEmployee = async (data) => {
  const response = await apiClient.post("/users/admin/create/", data);
  return response.data;
}
